<template>
    <div style="margin-top: 1em;">
        <h3>Licensing</h3>
        <div class="row pb-6">
            <div class="col">
                <div class="sau-bx bx-pad">
                    <div class="row">

                        <sau-spinner class="w-100" v-if="! loaded" />
                        <template v-else>
                            <template v-if="licenseCount == 0">
                                <!-- Update as we add new licences -->
                                <p v-if="error">Unable to fetch licencing information, please try again later.</p>
                                <p v-else>You don't have any cPanel licences linked to this service</p>
                            </template>
                            <template v-else>
                                <div v-for="(val, key) in licenses" :key="key" class="col-sm-12 col-md-6">
                                    <ul class="sau-list-display">
                                        <li>
                                            <h5>{{ val.name }}</h5>
                                            <template v-if="val.type === 'cpanel'">
                                                <template v-if="val.maxusers > 0">
                                                    <p>{{ val.accounts_count + ' / ' + val.maxusers }} currently assigned</p>
                                                </template>
                                                <template v-else>
                                                    <p>{{ val.accounts_count }} currently assigned</p>
                                                    <p>(est {{val.estimated_fee | currency }} per month)</p>
                                                </template>
                                            </template>
                                        </li>
                                    </ul>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import SauSpinner from '@v1/utilities/SauSpinner';

export default {
    components: { SauSpinner },
    data() {
        return {
            loaded: false,
            licenses: [],
            error: false
        }

    },
   created() {
       this.loadLicensing();
   },
   methods: {
        loadLicensing() {
            axios.get('/api/services/' + this.getServiceType() + '/' + this.getServiceId() + '/licensing')
                .then(response => {
                    this.licenses = response.data;
                }).catch(error => {
                    this.error = true;
                }).finally(() => {
                    this.loaded = true;
                });
        }
   },
   computed: {
       licenseCount() {
           return this.licenses.length;
       }
   }

}

</script>
